export class ClusterProduct {
  constructor(private clusterProductKey: ClusterProductKey, private ean: IndustryProductEan, private name: string) {}

  public getClusterProductKey(): ClusterProductKey {
    return this.clusterProductKey;
  }

  public getEan(): IndustryProductEan {
    return this.ean;
  }

  public getName(): string {
    return this.name;
  }

  public setClusterProductKey(value: ClusterProductKey) {
    this.clusterProductKey = value;
  }

  public setEan(value: IndustryProductEan) {
    this.ean = value;
  }

  public setName(value: string) {
    this.name = value;
  }
}

export class ClusterProductKey {
  constructor(private value: string) {}

  public getValue(): string {
    return this.value;
  }
  public setValue(value: string) {
    this.value = value;
  }
}

export class IndustryProductEan {
  constructor(private value: string) {}

  public getValue(): string {
    return this.value;
  }
  public setValue(value: string) {
    this.value = value;
  }
}
